<template>
  <v-container>
    <v-card class="mx-auto" outlined width="80%" max-width="500">
      <v-card-title class="justify-center">{{ title }}</v-card-title>
      <v-card-text class="px-10">
        <v-row>
          <v-col>
            <btn :label="$t('ELE0342')" @click="onClickSingleSignOn" color="primary" icon="mdi-microsoft-azure" block />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-divider />
            <span class="d-flex mx-3 text-body-2 justify-center">{{ 'or' }}</span>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <btn :label="$t('ELE0343')" @click="onClickEmsOnly" icon="mdi-microsoft-azure" color="#B7BADA" block />
          </v-col>
        </v-row>
      </v-card-text>
      <system-footer />
    </v-card>
  </v-container>
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'
import SystemFooter from '@/components/atoms/base/header-footer/Footer'

export default {
  name: 'SingleSignOnForm',

  components: {
    Btn,
    SystemFooter,
  },

  computed: {
    title: {
      get() {
        return this.$t('ELE0001') + ' (' + process.env.VUE_APP_STAGE + ')'
      },
    },
  },

  methods: {
    onClickSingleSignOn() {
      this.$emit('singleSignOn')
    },
    onClickEmsOnly() {
      this.$emit('singleSignOnEmsOnly')
    },
  },
}
</script>
